'use client';
import React from 'react';
import { toast } from 'sonner';

export const Overview = () => {
  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
    toast.success('Copied to clipboard!');
  };
  return (
    <div className="pt-[82px] lg:pt-[187px] w-full relative px-4">
      <div className="max-w-[1464px] w-full mx-auto relative flex flex-col gap-[52px] lg:gap-[144px]">
        <img
          src="/assets/alien12 1 (1).png"
          className="max-w-[176px] w-full absolute hidden lg:block bottom-[-153px] z-0 right-[90px]"
          alt=""
        />
        <div className="flex flex-col lg:pb-[66px] gap-5 items-center justify-center text-center">
          <h2 className="text-[60px] font-normal font-koulen leading-[100%] uppercase">
            Testnet <span className="text-[#D6FF00]">Overview</span>
          </h2>
          <p className="text-2xl hidden lg:block max-w-[902px] w-full font-koulen leading-[130%] uppercase">
            This network mirrors the upcoming Layer Brett mainnet, giving users early access to test transactions,
            governance, and our AI-powered meme ecosystem
          </p>
          <p className="text-[20px] text-center  lg:hidden max-w-[902px] w-full font-koulen leading-[130%] uppercase">
            A fast, low-cost Optimism Layer 2 — infused with Brett culture and powered by Ethereum Sepolia for testing.
          </p>
        </div>

        <div className=" grid grid-cols-1 lg:grid-cols-2  ">
          <div className="flex flex-col gap-4 lg:gap-[13px]">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <span className="font-obriton font-[900] text-lg leading-[107%] text-white">Network Name:</span>
              <div className="bg-[#0487AB] max-lg:w-full max-lg:h-[61px] flex items-center justify-center uppercase pl-[25px] pr-[36px] py-[9px] text-[24px] font-normal font-koulen text-[#D6FF00] leading-[100%] border-4 border-[#003E58] shadow-mobile2 lg:shadow-shadowSm rounded-[15px]">
                Layer Brett Testnet
              </div>
            </div>
            <div className="flex flex-col lg:flex-row items-center gap-5 lg:gap-[106px]">
              <span className="font-obriton font-[900] text-lg leading-[107%] text-white">Chain ID:</span>
              <div className="bg-[#0487AB] uppercase max-lg:w-full max-lg:h-[61px] flex items-center justify-center  pl-[25px] pr-[36px] py-[9px] text-[24px] font-normal font-koulen text-[#D6FF00] leading-[100%] border-4 border-[#003E58] shadow-mobile2 lg:shadow-shadowSm rounded-[15px]">
                4500
              </div>
            </div>

            <div className="flex flex-col lg:flex-row items-center gap-5 lg:gap-[93px]">
              <span className="font-obriton font-[900] text-lg leading-[107%] text-white">RPC URL:</span>

              <div className="bg-[#0487AB] flex gap-2 items-center uppercase pl-[25px] pr-[36px] py-[9px] text-[24px] font-normal font-koulen text-[#D6FF00] leading-[100%] border-4 border-[#003E58] shadow-mobile2 lg:shadow-shadowSm rounded-[15px]">
                <span>https://testnet-tx-rpc.layerbrettchain.com</span>

                <img
                  src="/assets/solar_copy-bold.png"
                  className="cursor-pointer"
                  onClick={() => handleCopy('https://testnet-tx-rpc.layerbrettchain.com')}
                  alt="copy"
                />
              </div>
            </div>

            <div className="flex flex-col lg:flex-row items-center gap-5 lg:gap-[29px]">
              <span className="font-obriton font-[900] text-lg leading-[107%] text-white">Block Explorer:</span>

              <div className="bg-[#0487AB] flex gap-2 items-center uppercase pl-[25px] pr-[36px] py-[9px] text-[24px] font-normal font-koulen text-[#D6FF00] leading-[100%] border-4 border-[#003E58] shadow-mobile2 lg:shadow-shadowSm rounded-[15px]">
                <span>https://testnet-explorer.layerbrettchain.com/</span>

                <img
                  src="/assets/solar_copy-bold.png"
                  className="cursor-pointer"
                  onClick={() => handleCopy('https://testnet-explorer.layerbrettchain.com/')}
                  alt="copy"
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col max-lg:pt-4 gap-4 lg:gap-[13px]">
            {/* Row */}
            <div className="flex flex-col lg:flex-row items-center gap-5 lg:gap-6">
              <span className="w-40 font-obriton font-[900] text-lg leading-[107%] text-white">
                Bridge Contract <span className="text-[#EF53C0]">(Sepolia L1)</span> :
              </span>

              <div className="bg-[#0487AB] break-all flex gap-2 items-center uppercase px-6 py-2 text-[24px] font-normal font-koulen text-[#D6FF00] leading-[100%] border-4 border-[#003E58] shadow-mobile2 lg:shadow-shadowSm rounded-[15px]">
                <span>0x10Ec8159a9B1D7b7A1154E9a5b89FCeCd027B222</span>

                <img
                  src="/assets/solar_copy-bold.png"
                  className="cursor-pointer"
                  onClick={() => handleCopy('0x10Ec8159a9B1D7b7A1154E9a5b89FCeCd027B222')}
                  alt="copy"
                />
              </div>
            </div>

            {/* Row */}
            <div className="flex flex-col lg:flex-row items-center gap-5 lg:gap-6">
              <span className="w-40 font-obriton font-[900] text-lg leading-[107%] text-white">Gas Token:</span>

              <div className=" bg-[#0487AB] uppercase max-lg:w-full max-lg:h-[61px] flex items-center justify-center  px-6 py-2 text-[24px] font-normal font-koulen text-[#D6FF00] leading-[100%] border-4 border-[#003E58] shadow-mobile2 lg:shadow-shadowSm rounded-[15px]">
                Sepolia ETH
              </div>
            </div>

            {/* Row */}
            <div className="flex flex-col lg:flex-row items-center gap-5 lg:gap-6">
              <span className="w-40 font-obriton font-[900] text-lg leading-[107%] text-white">Base Layer:</span>

              <div className=" bg-[#0487AB] uppercase max-lg:w-full max-lg:h-[61px] flex items-center justify-center  px-6 py-2 text-[24px] font-normal font-koulen text-[#D6FF00] leading-[100%] border-4 border-[#003E58] shadow-mobile2 lg:shadow-shadowSm rounded-[15px]">
                Ethereum Sepolia (L1)
              </div>
            </div>

            {/* Row */}
            <div className="flex flex-col lg:flex-row items-center gap-5 lg:gap-6">
              <span className="w-40 font-obriton font-[900] text-lg leading-[107%] text-white">Launch Date:</span>

              <div className=" bg-[#0487AB] uppercase max-lg:w-full max-lg:h-[61px] flex items-center justify-center  px-6 py-2 text-[24px] font-normal font-koulen text-[#D6FF00] leading-[100%] border-4 border-[#003E58] shadow-mobile2 lg:shadow-shadowSm rounded-[15px]">
                December 1st, 2025
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
